import React from 'react';

// The Figma "Edit" pencil. A flat single-stroke glyph (not a gradient tile),
// stroke uses currentColor so the parent controls the colour. 15x14 viewBox,
// kept at its own aspect ratio.
const EditPencilIcon = ({ width = 15, height = 14 }) => (
      <>
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 12.5H5L11.25 6.25L8.75 3.75L2.5 10V12.5Z"
            stroke="black"
            stroke-width="1.1875"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.75 3.75L11.25 6.25"
            stroke="black"
            stroke-width="1.1875"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
);

export default EditPencilIcon;
